import React from 'react';
import { STATUS_LABELS, STATUS_COLORS } from '../../constants/statuses';

export const StatusBadge = ({ status, className = '' }) => {
    const label = STATUS_LABELS[status] || (status ? status.toUpperCase() : 'UNKNOWN');
    const color = STATUS_COLORS[status] || '#334155'; // Default slate-700

    return (
        <div
            className={`relative group/badge px-4 py-1.5 flex items-center justify-center overflow-hidden select-none ${className}`}
            style={{
                backgroundColor: `${color}45`, // Stronger background for vibrancy
                backdropFilter: 'blur(8px)',
                borderRadius: '50px',
                boxShadow: `0 0 15px ${color}50, inset 0 0 8px rgba(255,255,255,0.25)`,
                border: `2px solid ${color}`,
                minWidth: '130px',
                display: 'inline-flex',
                height: '32px' // Slightly taller for more presence
            }}
        >
            <span
                className="relative z-10 text-[11px] font-black tracking-widest uppercase text-center leading-none"
                style={{
                    color: '#ffffff',
                    textShadow: `0 1px 2px rgba(0,0,0,0.5), 0 0 10px ${color}` // Solid text with aura
                }}
            >
                {label}
            </span>
        </div>
    );
};

export default StatusBadge;
